import { Formatters } from '../../gen-src/Localize';
import { TextAreaProps } from '../widgets/TextAreaWidget';

export type TextValidationProps = Pick<TextAreaProps, 'valid' | 'message'>;

const getTextValidity = (current: string, maximum: number): false | undefined => {
  if (current.length > maximum) { return false; }

  // design calls for no green border, so 'valid' is just grey (undefined)
  return undefined;
};

/**
 * A function which returns a localized validation message and state for character count validation
 * @param maximum the maximum number of characters allowed
 * @param current the current value of the string to validate
 */
export function getMaxCharValidation(current: string, maximum: number): TextValidationProps {
  const isTextValid = getTextValidity(current, maximum);
  const message = `${Formatters.formatCount(current.length)} / ${Formatters.formatCount(maximum)}`;

  return { message, valid: isTextValid };
}
